import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Row, Col, Card, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Can from 'components/Can';
import MasterPage from 'components/MasterPage';
import { DashboardOutlined } from '@material-ui/icons';

const Reports = () => {
  const { t } = useTranslation();

  function createCard(title, link, info) {
    return (
      <Col sm="12" md="6" lg="4">
        <Card.Body
          style={{ height: 'auto', minHeight:'95%', marginBottom: '15px' }}
          className="shadow bg-white rounded"
        >
          <Link to={link} className="text-primary font-weight-bold">
            {title}
          </Link>
          <Card.Text style={{ marginTop: '12px' }}>{info}</Card.Text>
          <Button
            block
            variant="primary-login"
            className="login-btn mr-1"
            size="md"
            as={Link}
            to={link}
          >Acessar </Button>
        </Card.Body>
      </Col>
    );
  }

  return (
    <div className="global">
      <Row className="col-12">
        <Col className="d-flex mt-3 mb-3">
          <DashboardOutlined className="icon-title" />
          <h4 className="title-dashboard mt-2">{t('title:reports')}</h4>
        </Col>
      </Row>
      <Row className="m-0 mt-3 mb-3 col-12">
        <Can do="viewGeneralReport" on="App">
          {createCard(
            'GERAL',
            'reports/general',
            'Relatório geral com valores captados, faturados, gastos de ações,' +
              'margem, recebido e a faturar.'
          )}
        </Can>

        <Can do="viewVendorsReport" on="App">
          {createCard(
            'FABRICANTE',
            'reports/vendors',
            'Relatório de listagem de fabricantes com entradas (fundos) e saídas (ações).'
          )}
        </Can>

        <Can do="viewActionAwaitingPaymentReport" on="App">
          {createCard(
            'AÇÕES AGUARDANDO RECEBIMENTO',
            'reports/actions-awaiting-payment',
            'Relatório de listagem de ações que estão aguardando recebimento, com fabricante e aging.'
          )}
        </Can>

        <Can do="viewContactsReport" on="App">
          {createCard(
            'CONTATOS',
            'reports/report-vendor-contact',
            'Relatório de listagem de contatos dos fabricantes.'
          )}
        </Can>

        <Can do="viewMarginMarketingPlanReport" on="App">
          {createCard(
            'MARGEM POR PLANO DE MARKETING',
            'reports/margin-marketing-plan',
            'Relatório de listagem de ações que fazem parte de um plano de marketing.'
          )}
        </Can>

        <Can do="viewMarginVendorReport" on="App">
          {createCard(
            'MARGEM POR FABRICANTE',
            'reports/margin-vendor',
            'Relatório de listagem de fabricantes com margem.'
          )}
        </Can>

        <Can do="viewUsersWithProfilesReport" on="App">
          {createCard(
            'USUÁRIOS COM PERFIL',
            'reports/users',
            'Relatório de listagem de usuários com perfil.'
          )}
        </Can>
        
        <Can do="viewVendorsWithUsersReport" on="App">
          {createCard(
            'FABRICANTES COM USUÁRIOS RESPONSÁVEIS',
            'reports/company',
            'Relatório de listagem de fabricantes com usuários responsáveis.'
          )}
        </Can>

        <Can do="viewEventsReport" on="App">
          {createCard(
            'EVENTOS',
            'reports/events',
            'Relatório de eventos.'
          )}
        </Can>

        <Can do="viewInvoicesReport" on="App">
          {createCard(
            'NOTAS',
            'reports/invoices',
            'Relatório de Notas.'
          )}
        </Can>

        <Can do="viewRulesByManufacturer" on="App">
          {createCard(
            'REGRAS POR FABRICANTE',
            'reports/rules-by-manufacturer',
            'Relatório de Regras por Fabricante.'
          )}
        </Can>

        {createCard(
          'VERBAS',
          'reports/funds',
          'Relatório de Verbas.'
        )}
        <Can do="viewFundsByCompany" on="App">
          {createCard(
            'VERBAS POR FABRICANTE',
            'reports/funds-by-company',
            'Relatório de Verbas por Fabricante.'
          )}
        </Can>

        <Can do="viewActionsReport" on="App">
          {createCard(
            'AÇÕES',
            'reports/actions',
            'Relatório de Ações.'
          )}
        </Can>
      </Row>
    </div>
  );
};

const mapStateToProps = (state) => ({});
const mapDispatchToProps = (dispatch) => ({});
const reduxConnect = connect(mapStateToProps, mapDispatchToProps)(Reports);

export default MasterPage(reduxConnect);
